import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MenuPackage } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu-injector";
import { ContextMenuService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu.service";
import { MenuComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/menu.component";
import { AccountService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { take } from "rxjs/operators";
import { InvDailySettingComponent } from "./inv-daily-setting/inv-daily-setting.component";

@Component({
  selector: "simple-menu",
  // add your menu html
  template: `
    <a *ngIf="this.menuPackage.context.visible" class="simple-menu-box" (click)="handleClick(this.menuPackage.context.value)">
      {{ "ClientApp.FrontOffice.Inv.DailyHeader.Settings" | translate }}
    </a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvDailyHeaderMenuComponent extends MenuComponent {
  DepositMenuComponent;
  // this module does not have animations, set lazy false
  lazy = false;

  constructor(
    public menuPackage: MenuPackage,
    public contextMenuService: ContextMenuService,
    public dialogService: SimpleModalService,
    public common: CommonService,
    public accountService: AccountService,
    protected sts: ShowToastrService
  ) {
    super(menuPackage, contextMenuService);
    // grab any required menu context passed via menuContext input
  }

  async handleClick(value: any) {
    this.contextMenuService.closeAll();
    this.dialogService
      .open(InvDailySettingComponent, { currentrow: value }, { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false })
      .pipe(take(1))
      .subscribe((model: any) => {
        this.menuPackage.context.settingChanges$?.next(true);
      });
  }
}
